import React from 'react';

import {
  IcApple24,
  IcBankCard28,
  IcBoleto56,
  IcGoogle24,
  IcMir56,
  IcOxxo56,
  IcPaypal24,
  IcPix56,
  IcSpei56,
} from '$assets';

export type MethodVisual = {
  icon: React.ReactNode;
  label: string;
  large?: boolean;
};

export const getMethodVisual = (
  method: string,
  t: (key: string) => string,
): MethodVisual => {
  switch (method) {
    case 'card':
      return { icon: <IcBankCard28 />, label: t('top_up_method_singularity') };
    case 'sbp':
      return {
        icon: (
          <div
            style={{
              backgroundImage: `url(${require('./sbp.png').default})`,
              width: 28,
              height: 28,
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
            }}
          />
        ),
        label: t('top_up_method_sbp'),
      };
    case 'apple_pay':
      return { icon: <IcApple24 />, label: 'Apple Pay' };
    case 'google_pay':
      return { icon: <IcGoogle24 />, label: 'Google Pay' };
    case 'paypal':
      return { icon: <IcPaypal24 />, label: 'PayPal' };
    case 'card_acquiring_rub':
      return { icon: <IcMir56 />, label: t('balance_inwizo'), large: true };
    case 'pix_brl':
      return { icon: <IcPix56 />, label: 'PIX', large: true };
    case 'boleto_brl':
      return { icon: <IcBoleto56 />, label: 'Boleto', large: true };
    case 'spei_mxn':
      return { icon: <IcSpei56 />, label: 'SPEI', large: true };
    case 'oxxopay_mxn':
      return { icon: <IcOxxo56 />, label: 'OXXO Pay', large: true };
    default:
      return { icon: <IcBankCard28 />, label: method };
  }
};

export const getPayErrorMessage = (
  err: any,
  t: (key: string, options?: Record<string, string>) => string,
): string | undefined =>
  err?.code === 'pay_method_unavailable'
    ? t('pay_method_unavailable', {
        method: getMethodVisual(err.params?.method, t).label,
        defaultValue:
          'Payment method "%{method}" is temporarily unavailable. Please choose another payment method or try again later.',
      })
    : err?.message;
